import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge conditional Tailwind class names without conflicting utility
 * duplication (`twMerge` dedupes the last-winning class per utility
 * family).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
